import {
  SET_SELLER_SERVICES,
} from '../constants/AppConstants';

const initialState = {
  sellerServices: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SELLER_SERVICES: {
      const sellerServices = action.payload;
      return {
        ...state,
        sellerServices
      }
    }
    default: {
      return state;
    }
  }
};
